export enum AzzurroHubErrorCode {
  Unauthorized = '403',
  UnknownError = '500',
  DeviceNotConnected = '503',
  Timeout = '001',
}

export class CmdAzzurroHubError extends Error {
  code: AzzurroHubErrorCode;

  constructor(message: string, code: AzzurroHubErrorCode) {
    super(message);
    this.name = 'CmdAzzurroHubError';
    this.code = code;
    Object.setPrototypeOf(this, CmdAzzurroHubError.prototype);
  }
}
